import * as React from 'react';
import { UserMedicineHistoryModel } from '../../../models/user/userMedicineHistoryModel';
import UserService from '../../../services/userService';
import Translate from '../../../common/functions/translate';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { fomatDateAsString } from '../../../common/functions/helperFunctions';
import { UserPrescriptionModel } from '../../../models/user/userPrescriptionModel';
import Spinner from '../../../common/components/spinner/spinner';
import UserMedicineAddEditDialog from './userMedicineAddEditDialog';
import AuthService from '../../../services/authService';
import UserNotificationListDialog from '../userNotification/userNotificationListDialog';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown, faChevronUp, faUserMd } from '@fortawesome/free-solid-svg-icons';
import Fab from '@material-ui/core/Fab';
import Growl from '../../../common/components/alertMessage/growl';
import * as Constants from '../../../common/constants';
import ExpandingList from '../../../common/components/expandingList/expandingList';
import CSSTransition from 'react-transition-group/CSSTransition';
import AddIcon from '@material-ui/icons/Add';
import NotificationsIcon from '@material-ui/icons/Notifications'

interface IProps {
  closeClick: any,
  userPrescriptionId: number,
  lang: string
}

interface IState {
  isLoading: boolean;
  validationMessage: string;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  currentUserPrescription: UserPrescriptionModel,
  isVisibleUserMedcineAddEditDialog: boolean,
  isMedicineButtonDisabled: boolean;
  currrentUserMedicineHistory: UserMedicineHistoryModel,
  userId: number;
  isVisibleUserNotificationListDialog: boolean;
  isVisibleConfirmDialog: boolean;
  expandedMedicine: Array<UserMedicineHistoryModel>
}

const initFrom = 0;
const numberOfRows = 10;

class PrescriptionMedicineListDialog extends React.Component<IProps, IState> {
  userService = new UserService();
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      validationMessage: '',
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      currentUserPrescription: new UserPrescriptionModel(),
      isVisibleUserMedcineAddEditDialog: false,
      isMedicineButtonDisabled: false,
      currrentUserMedicineHistory: new UserMedicineHistoryModel(),
      userId: 0,
      isVisibleUserNotificationListDialog: false,
      isVisibleConfirmDialog: false,
      expandedMedicine: new Array<UserMedicineHistoryModel>()
    }
  }

  componentDidMount() {
    this.getPrescriptionMedicines(this.props.userPrescriptionId);
  }

  getPrescriptionMedicines = (userPrescriptionId) => {
    if (!userPrescriptionId) {
      this.growl.show({ severity: 'error', summary: "PrescriptionID not valid" });
    } else {
      this.setState({
        isLoading: true
      });
      this.userService.getPrescriptionMedicines(userPrescriptionId, this.props.lang)
        .then(
          (data: UserPrescriptionModel) => {
            this.setCurrentUserPrescription(data);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    }
  }

  setCurrentUserPrescription(currentUserPrescription: UserPrescriptionModel) {
    this.setState({ currentUserPrescription: { ...currentUserPrescription } });
  }

  handleCloseButton = () => {
    this.props.closeClick();
  }

  //********************** Medicines methods *******************************************************************/
  handleUserMedicineAddEditClick = (userMedicineHistoryId) => {
    if (!userMedicineHistoryId) {
      let currrentUserMedicineHistory = new UserMedicineHistoryModel();

      if (this.state.currentUserPrescription.startDate) {
        currrentUserMedicineHistory.startDate = fomatDateAsString(new Date(this.state.currentUserPrescription.startDate));
      } else {
        currrentUserMedicineHistory.startDate = fomatDateAsString(new Date());
      }

      if (this.state.currentUserPrescription.endDate) {
        currrentUserMedicineHistory.endDate = fomatDateAsString(new Date(this.state.currentUserPrescription.endDate));
      } else {
        currrentUserMedicineHistory.endDate = fomatDateAsString(new Date());
      }

      this.setState({
        currrentUserMedicineHistory: currrentUserMedicineHistory
      });
      this.showUserMedicineAddEditDialog(true, false);
    } else {
      let userMedicineHistory = this.state.currentUserPrescription.userMedicines.find(m => m.userMedicineHistoryId === userMedicineHistoryId);

      if (userMedicineHistory) {
        this.setState({
          currrentUserMedicineHistory: userMedicineHistory
        });
      }
      this.showUserMedicineAddEditDialog(true, true);
    }

    if (!this.state.userId || this.state.userId <= 0) {
      if (this.authService.isAuthenticated()) {
        let profile = this.authService.getProfile();
        let id = profile['id'];
        this.setState({
          userId: id,
        });
      }
      else {
        console.log("EROR");
      }
    }
  }

  showUserMedicineAddEditDialog = (show: boolean, isButtonDisabled: boolean) => {
    this.setState({
      isVisibleUserMedcineAddEditDialog: show,
      isMedicineButtonDisabled: isButtonDisabled
    });
  }

  handleUserMedicineAddEditDialogCancelButton = () => {
    this.showUserMedicineAddEditDialog(false, false);
  }

  handleUserMedicineSave = (selectedUserMedicine: UserMedicineHistoryModel) => {
    this.setState({
      isLoading: true
    });

    if (!selectedUserMedicine.userMedicineHistoryId) {
      this.userService.addPrescriptionMedicine(this.props.userPrescriptionId, selectedUserMedicine)
        .then(
          (data) => {
            this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.getPrescriptionMedicines(this.props.userPrescriptionId);
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    } else {
      this.userService.updatePrescriptionMedicine(this.props.userPrescriptionId, selectedUserMedicine)
        .then(
          (data) => {
            this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.getPrescriptionMedicines(this.props.userPrescriptionId);
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          });
    }
    this.showUserMedicineAddEditDialog(false, false);
  }

  handleUserMedicineDeleteClick = (userMedicineHistoryId) => {
    let userMedicineHistory = this.state.currentUserPrescription.userMedicines.find(m => m.userMedicineHistoryId === userMedicineHistoryId);
    if (userMedicineHistory) {
      this.setState({
        currrentUserMedicineHistory: userMedicineHistory
      });
    }
    this.setState({
      isVisibleConfirmDialog: true
    });
  }

  deleteUserMedicine = (userMedicineHistoryId) => {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    if (userMedicineHistoryId && this.state.currentUserPrescription && this.state.currentUserPrescription.userPrescriptionId) {
      this.userService.deletePrescriptionMedicine(this.state.currentUserPrescription.userPrescriptionId, userMedicineHistoryId)
        .then(
          (data) => {
            this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
            this.getPrescriptionMedicines(this.props.userPrescriptionId);
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    }
    else {
      this.growl.show({ severity: 'error', summary: "Delete failed" });
      this.setState({
        isLoading: false
      });
    }
  }

  //********************** Notifications methods *******************************************************************/
  showUserNotificationListDialog = (show: boolean) => {
    this.setState({
      isVisibleUserNotificationListDialog: show
    });
  }

  handleUserNotificationButtonClick = (userMedicineHistoryId) => {
    if (!userMedicineHistoryId) {
      this.growl.show({ severity: 'error', summary: "UserMedicine ID is not valid" });
    } else {
      let userMedicineHistory = this.state.currentUserPrescription.userMedicines.find(m => m.userMedicineHistoryId === userMedicineHistoryId);

      if (userMedicineHistory) {
        this.setState({
          currrentUserMedicineHistory: userMedicineHistory
        });
      }
      this.showUserNotificationListDialog(true);
    }
  }

  handleUserNotificationListDialogCloseButton = () => {
    this.getPrescriptionMedicines(this.props.userPrescriptionId);
    this.showUserNotificationListDialog(false);
  }

  expandedData = (rowData: UserMedicineHistoryModel) => {
    const classrs = {
      backgroundColor: '#17a2b8',
      color: 'white',
      border: 'none',
      borderRadius: '3px',
      marginRight: ".5em",
      fontSize: 16,
      width: 50
    }

    return (
      <div className="item-actions-panel">
        <button
          data-tip={Translate('Diseases')}
          type="button"
          className="btn btn-info item-actions-panel-buttons"
          style={classrs}
          onClick={() => this.handleUserNotificationButtonClick(rowData.userMedicineHistoryId)}>
          <FontAwesomeIcon style={{ verticalAlign: 'text-top' }} icon={faBell}></FontAwesomeIcon>
        </button>

        <button
          type="button"
          className="p-button-warning item-actions-panel-buttons"
          style={{
            marginRight: ".5em", fontSize: 16, backgroundColor: '#ffba01', color: 'black', border: 'none',
            borderRadius: '3px',
          }}
          onClick={() => this.handleUserMedicineAddEditClick(rowData.userMedicineHistoryId)}
        > <i style={{ verticalAlign: 'text-top' }} className="pi pi-pencil"></i></button>
        <button
          type="button"
          className="p-button-danger item-actions-panel-buttons"
          style={{
            marginRight: ".5em", fontSize: 16, backgroundColor: '#e91224', color: 'white', border: 'none',
            borderRadius: '3px',
          }}
          onClick={() => this.handleUserMedicineDeleteClick(rowData.userMedicineHistoryId)}
        ><i style={{ verticalAlign: 'text-top' }} className="pi pi-trash"></i></button>
      </div>
    );
  }

  rowExpansionTemplate = (rowData: UserMedicineHistoryModel) => {
    return (
      <CSSTransition in={this.state.expandedMedicine.some(r => r.userMedicineHistoryId == rowData.userMedicineHistoryId)}
        timeout={300} classNames="list-slide" mountOnEnter unmountOnExit>
        {this.expandedData(rowData)}
      </CSSTransition>
    );
  }

  expandData = (data: UserMedicineHistoryModel) => {
    if (!this.state.expandedMedicine.some(r => r.userMedicineHistoryId == data.userMedicineHistoryId) || this.state.expandedMedicine.length == 0) {
      this.setState({ expandedMedicine: [...this.state.expandedMedicine, data] });
    } else {
      this.setState({ expandedMedicine: this.state.expandedMedicine.filter(r => r.userMedicineHistoryId != data.userMedicineHistoryId) });
    }
  }

  keyItem = (m: UserMedicineHistoryModel) => {
    return m.userMedicineHistoryId + 'umedId';
  }

  itemName = (m: UserMedicineHistoryModel) => {
    return m.medicineName;
  }

  itemDesc = (m: UserMedicineHistoryModel) => {
    return (
      <>
        <div>{m.singleDose ? Translate("Single Dose") + ': ' + m.singleDose : null}</div>
        <div>{m.frequencyOfIntake ? Translate("Frequency Of Intake") + ': ' + m.frequencyOfIntake : null}</div>
        <div>{m.intakeConditions ? Translate("Intake Conditions") + ': ' + m.intakeConditions : null}</div>
        {HelperFunctions.fomatDatesStringWithLang(new Date(m.startDate ? m.startDate : ''), this.props.lang) + " - "}
        {HelperFunctions.fomatDatesStringWithLang(new Date(m.endDate ? m.endDate : ''), this.props.lang)}
        <div className="interactions-result-badge">
          <NotificationsIcon fontSize="small" style={{ paddingRight: '5px' }} />
          {Translate('Alarms')}
          <div className="badge text-badge">
            {m.notificationsCount ? m.notificationsCount : '0'}
          </div>
        </div>
      </>
    )
  }

  itemActions = (m: UserMedicineHistoryModel) => {
    return (
      <>
        {window.innerWidth >= Constants.device.tablet ? this.expandedData(m) :

          this.state.expandedMedicine.some(r => r.userMedicineHistoryId == m.userMedicineHistoryId) ?
            <FontAwesomeIcon icon={faChevronUp} />
            : <FontAwesomeIcon icon={faChevronDown} />
        }
      </>
    )
  }

  render() {
    const { isLoading, currentUserPrescription, userId, currrentUserMedicineHistory } = this.state;

    let dialogHeader: string = Translate('Medicines');
    let contentHeader = Translate('Medicines') + " " + Translate('for') + " " + Translate('prescription')
      + " " + ((currentUserPrescription && currentUserPrescription.prescription) ? currentUserPrescription.prescription : "");

    return (
      <>
        {isLoading ? <Spinner /> : null}
        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
        <Growl ref={(el) => this.growl = el} />
        <div>{Translate('MedicinesForPrescription')}: </div>
        <h3>{HelperFunctions.fomatDatesStringWithLang(new Date(currentUserPrescription.startDate ? currentUserPrescription.startDate : ''), this.props.lang) + " - "}
          {HelperFunctions.fomatDatesStringWithLang(new Date(currentUserPrescription.endDate ? currentUserPrescription.endDate : ''), this.props.lang)}</h3>
        <div className="interactions-result-badge" style={{ height: 20, color: '#999' }}>
          <FontAwesomeIcon style={{ paddingRight: '5px', width: '24px', height: '15px' }} icon={faUserMd} />
          <h4>{currentUserPrescription.doctor}</h4>
        </div>
        <div style={{ marginTop: '15px' }}>
          <Fab color="primary" aria-label="Add" size="small" onClick={() => this.handleUserMedicineAddEditClick(null)} className="floating-action-button">
            <AddIcon />
          </Fab>
          <ExpandingList
            listItems={currentUserPrescription.userMedicines}
            keyItem={this.keyItem}
            expandData={this.expandData}
            expandedPanel={this.rowExpansionTemplate}
            itemName={this.itemName}
            itemDesc={this.itemDesc}
            itemActions={this.itemActions}
            isExpandable={window.innerWidth < Constants.device.tablet}
            infoStyle={window.innerWidth < Constants.device.tablet ? {} : { width: 'unset' }}
          />
          {!isLoading && (!currentUserPrescription.userMedicines || currentUserPrescription.userMedicines.length == 0) ? Translate("No records found") : null}
        </div>

        {this.state.isVisibleUserMedcineAddEditDialog ? (
          <UserMedicineAddEditDialog
            isMedicineButtonDisabled={this.state.isMedicineButtonDisabled}
            userId={userId}
            selectedMedicineHistory={this.state.currrentUserMedicineHistory}
            isVisible={this.state.isVisibleUserMedcineAddEditDialog}
            saveClick={this.handleUserMedicineSave}
            cancelClick={this.handleUserMedicineAddEditDialogCancelButton}
            lang={this.props.lang}
          />) : null}

        {this.state.isVisibleUserNotificationListDialog ? (
          <UserNotificationListDialog
            userMedicineHistoryId={this.state.currrentUserMedicineHistory.userMedicineHistoryId}
            isVisible={this.state.isVisibleUserNotificationListDialog}
            closeClick={this.handleUserNotificationListDialogCloseButton}
            lang={this.props.lang}
          />) : null}

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteUserMedicine(currrentUserMedicineHistory.userMedicineHistoryId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          {Translate("Confirm Message") + " "}
          {(currrentUserMedicineHistory ? ('"' + currrentUserMedicineHistory.medicineName + '"')
            : "this record")}?
        </ConfirmDialog>

      </>
    )
  }
}


export default PrescriptionMedicineListDialog;
